function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M16 30.6667C13.9962 30.6665 12.0387 30.0643 10.3812 28.9383C8.72375 27.8122 7.44281 26.2142 6.70446 24.3514C5.96612 22.4886 5.80444 20.4469 6.24038 18.4911C6.67632 16.5353 7.68977 14.7556 9.14934 13.3827C10.9387 11.6987 15.3333 8.66667 14.6667 2C22.6667 7.33333 26.6667 12.6667 18.6667 20.6667C20 20.6667 22 20.6667 25.3333 17.3733C25.6933 18.404 26 19.512 26 20.6667C26 23.3188 24.9464 25.8624 23.0711 27.7377C21.1957 29.6131 18.6522 30.6667 16 30.6667Z"
});

function SvgFireFill(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFireFill);
export default __webpack_public_path__ + "static/media/fire-fill.6530a7a2.svg";
export { ForwardRef as ReactComponent };